import React, { useLayoutEffect, useRef } from 'react';

function AutoResizingTextArea({ value, disabled, className, onChange, ...props }) {
  const textareaRef = useRef(null);

  // Recalculate height whenever value changes.  useLayoutEffect runs before
  // the browser paints so the user never sees the textarea at a stale height.
  // Setting height to 0 first forces scrollHeight to report true content
  // height — using 'auto' would work in most contexts but '0px' is more
  // robust if this component is ever placed inside a flex container.
  useLayoutEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = '0px';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  const safeValue = value === null || value === undefined ? '' : value;

  return (
    <textarea
      ref={textareaRef}
      value={safeValue}
      disabled={disabled}
      onChange={onChange}
      className={`w-1/2 ml-5 px-3 py-2 border rounded-md ${disabled ? 'bg-gray-100 text-gray-700' : 'bg-white text-black'} ${className}`}
      style={{ overflow: 'hidden', resize: 'none', minHeight: '2.5rem' }}
      rows={1}
      {...props}
    />
  );
}

export default AutoResizingTextArea;